/**
 * apps/battle/client/src/terminal/components/AttemptDots.tsx
 * Renders attempt indicator dots: ●●● → ●●○ → ●○○ → ○○○
 *
 * `remaining` = attempts left (including the one currently displayed).
 * `total`     = max attempts for this question.
 */
interface AttemptDotsProps {
  remaining: number;
  total: number;
}

export function AttemptDots({ remaining, total }: AttemptDotsProps) {
  const r = Math.max(0, Math.min(total, remaining));
  const dots = '\u25CF'.repeat(r) + '\u25CB'.repeat(Math.max(0, total - r));
  const low = r <= 1;
  return (
    <span
      className={`tm-dots${low ? ' tm-dots--low' : ''}`}
      aria-label={`${r} of ${total} attempts remaining`}
    >
      {dots}
    </span>
  );
}
